export const SELECT_TIMEZONE = 'SESSION:SELECT_TIMEZONE';